<template>
  <a-select
      :allowClear="true"
      v-model:value="value"
      :disabled="info.status === 'show'"
      style="width: 100%"
      :mode=" multi ? 'multiple' : undefined"
      :placeholder="info.title + '等于'"
  >
    <a-select-option
        v-for="option in widget.options"
        :value="option.value"
        :key="option.value"
    >
      {{ option.name }}
    </a-select-option>
  </a-select>
</template>

<script setup lang="ts">
import {computed, defineProps} from 'vue';
import {SelectSearch,} from '@/components/business/crud/interface/SearchType';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";
import {ScForm} from "@/models/ScForm";


const props = defineProps<{
  propName: string;
  widget: SelectSearch;
  info: WidgetInfo;
}>();
const multi = props.widget.options.length > 2;

const data = ScForm.useFormData();

const value = computed<string | string[] | undefined>({
  get() {
    if (multi) {
      if (data.value[props.propName]?.$in instanceof Array) {
        return data.value[props.propName].$in;
      } else {
        return [];
      }
    } else {
      return data.value[props.propName]?.$eq;
    }
  },
  set(value) {
    if (multi) {
      if (!data.value[props.propName]) {
        data.value[props.propName] = {}
      }
      if (value instanceof Array && value.length > 0) {
        data.value[props.propName].$in = value
      } else {
        data.value[props.propName].$in = undefined
      }
    } else {
      data.value[props.propName] = value
    }
  }
})


</script>

<style lang="scss" scoped></style>
